var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 116,
    viewBox: "0 0 430 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0946 13.8138C13.1866 5.89699 19.9528 0 27.9446 0H414C422.837 0 430 7.16344 430 16V100C430 108.837 422.837 116 414 116H16.3584C6.65269 116 -0.817717 107.428 0.508441 97.8138L12.0946 13.8138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBg);
export default __webpack_public_path__ + "static/media/time_bg.3ae78d8ebdd9fd13628f0e41447c4ac1.svg";
export { ForwardRef as ReactComponent };